import React from "react";
import { Document, Page } from "react-pdf";
import { DocumentIcon } from "@heroicons/react/24/outline";

const PDFPreview = ({ base64Url, uploadedFile }) => {
  const pdfDataBase64 = `data:application/pdf;base64,${base64Url}`;

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-200 w-[280px] min-w-[280px] flex flex-col">
      <div className="px-3 py-2 border-b border-gray-200 bg-gray-50/50">
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Document Preview
        </span>
      </div>
      <div className="flex-1 overflow-hidden bg-gray-100 min-h-[280px] flex items-center justify-center">
        <Document
          error=""
          loading={
            <div className="flex flex-col items-center gap-2 p-6">
              <div className="w-10 h-10 rounded-xl bg-gray-200 animate-pulse" />
              <span className="text-sm text-gray-500">Loading...</span>
            </div>
          }
          file={pdfDataBase64}
        >
          {Array.from(new Array(1), (el, index) => (
            <div
              key={index}
              className="flex justify-center items-center p-4"
            >
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={260}
                scale={1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            </div>
          ))}
        </Document>
      </div>
      <div className="p-4 border-t border-gray-200">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <DocumentIcon className="h-5 w-5 text-primary" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-gray-900 truncate">
              {uploadedFile?.fileName || "Document"}
            </p>
            <p className="text-xs text-gray-500 mt-0.5">
              {formatFileSize(uploadedFile?.fileSize || 0)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFPreview;
